// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../contexts/ConfigContext';
import styles from './notFound.module.scss';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { config, logo } = useConfig();

  const handleGoHome = (): void => {
    navigate('/');
  };

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.content}>
        <div className={styles.logoSection}>
          <img src={logo as string} alt={`${config?.companyName || 'G42'} Logo`} width={25} height={25} />
          <span className={styles.logoText}>{config?.companyName || 'G42'}</span>
        </div>

        <div className={styles.errorCode}>404</div>
        <h1 className={styles.title}>Page not found</h1>
        <p className={styles.description}>The page you're looking for doesn't exist or has been moved.</p>

        <button className={styles.homeButton} onClick={handleGoHome}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          Go to home
        </button>

        <div className={styles.helpText}>
          If you believe this is an error, please contact support or try refreshing the page.
        </div>
      </div>
    </div>
  );
};

export default NotFound;
